import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ItemDetails from '../DetailsForm';

import { Button } from '../../../../Styles';
import { AddIcon } from '../../../../Styles';

const AddItem = ({ refresh = null, ...props }) => {
	const { disableSingleInventoryCreate } = props;
	const [openAddItem, setOpenAddItem] = useState(false);

	return (
		<>
			{!disableSingleInventoryCreate && (
				<Button
					primary
					onClick={(e) => setOpenAddItem(true)}
				>
					<AddIcon />
					Add New Item
				</Button>
			)}

			<ItemDetails
				open={openAddItem}
				onSubmit={() => {
					if (refresh) {
						refresh();
					}
				}}
				onClose={() => {
					setOpenAddItem(false);
				}}
			/>
		</>
	);
};

const mapStateToProps = (state) => {
	const supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	const userSellerPortalConfig = state.session.sellerPortalConfig || {};

	const disableSingleInventoryCreate = supplierSellerPortalConfig.disable_single_inventory_create || userSellerPortalConfig.disable_single_inventory_create || false;

	return {
		disableSingleInventoryCreate,
	};
};

const mapDispatch = {};

export default withRouter(connect(mapStateToProps, mapDispatch)(AddItem));
